import { ActivityLogAgreementState } from '~/models';
const NOTIFICATION_BUCKET_MAP = {
    RelationshipApprovedCustomer: 'ProposalLifecycle',
    RelationshipUpdatedWithChanges: 'Amendments',
    AmendmentApprovalReminderCustomer: 'Amendments',
    BankAccountNotVerifiedReminderCustomer: 'Payment',
    RequestPaymentMethod: 'Payment',
    PaymentFailedCustomer: 'Payment',
    InvoiceRefundedCustomer: 'Payment',
    InvoiceIssued: 'Invoices',
    AdHocInvoiceIssued: 'Invoices',
    AdHocInvoiceOverdueReminderCustomer: 'Invoices'
};
const AGREEMENT_STATE_BUCKET_MAP = {
    [ActivityLogAgreementState.Sent]: 'ProposalLifecycle',
    [ActivityLogAgreementState.SentSilently]: 'ProposalLifecycle',
    [ActivityLogAgreementState.Reviewed]: 'ProposalLifecycle',
    [ActivityLogAgreementState.Approved]: 'ProposalLifecycle',
    [ActivityLogAgreementState.Terminated]: 'ProposalLifecycle',
    [ActivityLogAgreementState.SignedExternally]: 'ProposalLifecycle',
    [ActivityLogAgreementState.SigningReminderSent]: 'ProposalLifecycle',
    [ActivityLogAgreementState.SigningReminderSentManual]: 'ProposalLifecycle',
    [ActivityLogAgreementState.WithdrawnForEditing]: 'ProposalLifecycle',
    [ActivityLogAgreementState.Republished]: 'ProposalLifecycle',
    [ActivityLogAgreementState.TitleUpdated]: 'ProposalLifecycle',
    [ActivityLogAgreementState.SellerUpdated]: 'ProposalLifecycle',
    [ActivityLogAgreementState.LegalTermsUpdated]: 'ProposalLifecycle',
    [ActivityLogAgreementState.Changed]: 'Amendments',
    [ActivityLogAgreementState.ChangesApproved]: 'Amendments',
    [ActivityLogAgreementState.ChangesAutoApproved]: 'Amendments',
    [ActivityLogAgreementState.StoppedAutoApproval]: 'Amendments',
    [ActivityLogAgreementState.AmendmentApprovalReminderSent]: 'Amendments',
    [ActivityLogAgreementState.AmendmentsApprovalMethodUpdated]: 'Amendments',
    [ActivityLogAgreementState.ServiceTermsUpdated]: 'Amendments',
    [ActivityLogAgreementState.ServiceTermsRemoved]: 'Amendments',
    [ActivityLogAgreementState.PaymentMethod]: 'Payment',
    [ActivityLogAgreementState.PaymentMethodChanged]: 'Payment',
    [ActivityLogAgreementState.PaymentMethodDisconnected]: 'Payment',
    [ActivityLogAgreementState.RequestedPaymentMethod]: 'Payment',
    [ActivityLogAgreementState.MicroDeposit]: 'Payment',
    [ActivityLogAgreementState.MicroDepositStarted]: 'Payment',
    [ActivityLogAgreementState.MicroDepositStartedV2]: 'Payment',
    [ActivityLogAgreementState.MicroDepositFailed]: 'Payment',
    [ActivityLogAgreementState.MicroDepositFailedV2]: 'Payment',
    [ActivityLogAgreementState.MicroDepositVerified]: 'Payment',
    [ActivityLogAgreementState.MicroDepositVerifiedV2]: 'Payment',
    [ActivityLogAgreementState.MicroDepositReminderSent]: 'Payment',
    [ActivityLogAgreementState.MicroDepositRestarted]: 'Payment',
    [ActivityLogAgreementState.ManualPaymentsUpdated]: 'Payment',
    [ActivityLogAgreementState.CoverCreditCardFeesUpdated]: 'Payment',
    [ActivityLogAgreementState.InvoicesApprovalMethodUpdated]: 'Payment',
    [ActivityLogAgreementState.PracticeManagementContactCreated]: 'Integrations',
    [ActivityLogAgreementState.PracticeManagementItemsCreated]: 'Integrations'
};
// Proposal-lifecycle notifications are excluded from StandaloneNotificationType (they render via the
// fallback headline), but they must still route to the Proposal lifecycle chip — otherwise they vanish
// the moment that filter is applied.
const PROPOSAL_LIFECYCLE_NOTIFICATION_TYPES = new Set([
    'RelationshipNewProposalCustomer',
    'RelationshipSigning',
    'ProposalApprovalManualReminder'
]);
export const bucketFor = (notificationType)=>{
    var _NOTIFICATION_BUCKET_MAP_notificationType;
    if (PROPOSAL_LIFECYCLE_NOTIFICATION_TYPES.has(notificationType)) return 'ProposalLifecycle';
    return (_NOTIFICATION_BUCKET_MAP_notificationType = NOTIFICATION_BUCKET_MAP[notificationType]) !== null && _NOTIFICATION_BUCKET_MAP_notificationType !== void 0 ? _NOTIFICATION_BUCKET_MAP_notificationType : null;
};
export const bucketForEntry = (entry)=>{
    var _AGREEMENT_STATE_BUCKET_MAP_entry_state;
    if (entry.isSentNotificationEntry()) return bucketFor(entry.state());
    if (entry.isInvoiceEntry()) return 'Invoices';
    if (entry.isChargeEntry()) return 'Payment';
    if (entry.isAgreementEntry()) return (_AGREEMENT_STATE_BUCKET_MAP_entry_state = AGREEMENT_STATE_BUCKET_MAP[entry.state()]) !== null && _AGREEMENT_STATE_BUCKET_MAP_entry_state !== void 0 ? _AGREEMENT_STATE_BUCKET_MAP_entry_state : null;
    return null;
};
